import React from 'react'
import getEnumTranslation from '@/enums/enums'
import { useLocalization } from '@/hooks/localization'

export default ({ enumName, value, visualStatus }) => {
  const { localize } = useLocalization()
  let status = value
  if (typeof visualStatus === 'function') {
    status = visualStatus(value)
  } else if (typeof visualStatus === 'object' && visualStatus.length > value) { // array
    status = visualStatus[value]
  }
  const className = `status status--${status}`
  return (<span className={className}>
    {getEnumTranslation({ localize, enumName, value })}
  </span>)
}



// WEBPACK FOOTER //
// ./src/components/StatusEnum.js